import { isEmpty, map } from 'lodash/fp';
import { ValuePropositions } from '@ahmdigital/ui';
import type { ComponentProps } from 'react';

import { CONTENT_SECTIONS } from '../../../content/sections';
import getImageAttributes from '../../../../../cms/utils/get-image-attributes';
import type { ImageObject, UrlObject } from '../../../../../types/__codegen__/sanity/graphql';
import type { SectionValuePropositionType } from '../../../types';

type MapValuePropositionsContentProps = {
  cmsSectionContent: SectionValuePropositionType | null | undefined;
};

type MappedValuePropositionsContent = ComponentProps<typeof ValuePropositions> & {
  type: typeof CONTENT_SECTIONS.VALUE_PROPOSITIONS;
};

const mapCta = (urlObject?: UrlObject | null) =>
  urlObject?.name && urlObject?.url
    ? {
        title: urlObject.name,
        to: urlObject.url,
      }
    : undefined;

const mapValuePropositionsContent = ({
  cmsSectionContent,
}: MapValuePropositionsContentProps): MappedValuePropositionsContent | null => {
  if (isEmpty(cmsSectionContent)) {
    return null;
  }

  const cta = mapCta(cmsSectionContent?.urlObject);
  const mappedCmsContent = {
    ...(cta && { cta }),
    description: cmsSectionContent?.descriptionRaw,
    tiles: map(
      (valueProposition) => ({
        cta: mapCta(valueProposition?.urlObject) ?? null,
        image:
          getImageAttributes({ height: 352, imageObject: valueProposition?.imageObject as ImageObject }) ?? undefined,
        summary: valueProposition?.summaryRaw,
        title: valueProposition?.sloganRaw,
      }),
      cmsSectionContent?.valuePropositions ?? [],
    ),
    title: cmsSectionContent?.title,
    type: CONTENT_SECTIONS.VALUE_PROPOSITIONS,
    withSimpleBit: false,
  };

  return mappedCmsContent;
};

export default mapValuePropositionsContent;
